export default __webpack_public_path__ + "static/media/https1.13aeafbe.jpg";